import {
  GET_PATIENT_CASES,
  GET_PATIENT_INFORMATION,
} from "@/views/csr/store/typeDefs/patient";
import patientApiService from "@/views/csr/services/api/patient";

const patientStoreModule = {
  actions: {
    async [GET_PATIENT_INFORMATION](_, patientID) {
      try {
        return await patientApiService.getInformation(patientID);
      } catch (_) {
        return null;
      }
    },

    async [GET_PATIENT_CASES](_, patientID) {
      try {
        const result = await patientApiService.getCases(patientID);
        return result.data;
      } catch (_) {
        return [];
      }
    },
  },
};

export default patientStoreModule;
